import { Pipe, PipeTransform } from '@angular/core';
import { LogService } from '@services/log.service';

@Pipe({
    name: 'plantStockSorting',
    standalone: false
})
export class PlantStockSortingPipe implements PipeTransform {

  constructor(private logService: LogService) {}

  transform(values: any[]): any[] {
    this.logService.debug({ inputLength: values?.length, inputValues: values }, 'PlantStockSortingPipe', 'transform');

    if (!values) {
      this.logService.debug(`Returning empty array (values is null/undefined)`, 'PlantStockSortingPipe', 'transform');
      return []
    }

    if (values.length < 3) {
      this.logService.debug(`Returning original array length: ${values.length}`, 'PlantStockSortingPipe', 'transform');
      return values
    }
    
    const a = values[1]
    const b = values[2]
    const c = values[0]
    const result = [a, b, c]
    
    this.logService.debug(a, 'PlantStockSortingPipe',  'transform');
    this.logService.debug(b, 'PlantStockSortingPipe',  'transform');
    this.logService.debug(c, 'PlantStockSortingPipe',  'transform');
    return result
  }

}